export default {
  styleOverrides: {
    root: {
      "&.MuiMenu-paper": {
        marginTop: 0
      }
    }
  }
};
